/**
 * AARKA Scroll System
 * Initializes GSAP ScrollTrigger for scroll-driven sections.
 * All scroll-driven sections consume this via window.AARKA.
 */
(function () {
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      // Libraries not loaded yet, retry
      setTimeout(init, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Expose globally for sections to use
    window.AARKA = window.AARKA || {};
    window.AARKA.gsap = gsap;
    window.AARKA.ScrollTrigger = ScrollTrigger;
    window.AARKA.ready = true;

    // Dispatch event so sections know the system is ready
    document.dispatchEvent(new CustomEvent('aarka:scroll-ready'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
